import React, { useEffect, useState } from 'react';
import SuccessModal from '../ManageUser/SuccessModal';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import InviteUserForm from '../UI/Form/InviteUserForm';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const InviteUserModal = ({ setSelectedAction }) => {
    const { content } = useContentfulContext();

    const [countdown, setCountdown] = useState(content.INVITE_USER_SUCCESS_MODAL.timeout);
    const [isCountdownActive, setIsCountdownActive] = useState(false);

    const startCountdown = () => {
      setIsCountdownActive(true);
      setCountdown(content.INVITE_USER_SUCCESS_MODAL.timeout);
  
      const countdownInterval = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown === 1) {
            clearInterval(countdownInterval);
            setIsCountdownActive(false);
            setSelectedAction();
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    };
  
    useEffect(() => {
      if (countdown === 0) {
        setIsCountdownActive(false);
      }
    }, [countdown]);
    
    return (
        <>
            { isCountdownActive && <SuccessModal trigger={setSelectedAction} countdown={countdown} description={content.INVITE_USER_SUCCESS_MODAL.description} cta_text={content.INVITE_USER_SUCCESS_MODAL.close_cta_text} title={content.INVITE_USER_SUCCESS_MODAL.title} /> }
            { !isCountdownActive && <PrimaryModal title={content.INVITE_USER_MODAL.title} hideModal={setSelectedAction}>
                <div className='p-6 space-y-6'>
                  <InviteUserForm startCountdown={startCountdown} setShowInviteUserModal={setSelectedAction} />
                </div>
            </PrimaryModal> }
        </>
    )
}

export default InviteUserModal;